import "./App.scss";
import AboutSection from "./components/AboutSection";
import Footer from "./components/Footer";
import Header from "./components/Header";
import PortfolioGallery from "./components/PortfolioGallery";

const App = () => (
  <div className="app-container">
    <Header />
    <AboutSection />
    <PortfolioGallery />
    <Footer />
  </div>
);

export default App;
